/** Lowercase + strip Vietnamese diacritics for Spotlight matching. */
export const normalizeQuery = (value: string): string =>
  value
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .trim();
